import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import PrivacyPolicy from '../components/PrivacyPolicy'
import ScrollToTop from '../components/ScrollToTop'

function Politique() {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }
    return (
        <div>
            <ScrollToTop />
            <Sidebar isOpen={isOpen} toggle={toggle} />

            <Navbar toggle={toggle} />

            <PrivacyPolicy />

            <Footer />
        </div>
    )
}

export default Politique